import React from 'react';

import { alertCircle, questionMarkCircle } from '@/assets/icons';
import { RenderRichText } from '@/components/Layout/components/SongModalPanel/SongModalRoot';
import { classNames } from '@/helpers/classNames';
import { Capacitor } from '@capacitor/core';
import { SvgIcon } from '@material-ui/core';
import { to } from 'mathjs';

import { BottomCard, BottomCardAction, BottomCardForm } from '../../BottomCard';
import { AsaphButton } from '../../Button';
import styles from './Label.module.scss';

const isCapacitor = Capacitor.isNativePlatform();

type LabelProps = {
	className?: string;
	withOffset?: boolean;
	tooltip?: string;
	tooltipHeading?: string;
};

export const Label: React.FC<LabelProps> = ({
	className,
	withOffset,
	children,
	tooltip,
	tooltipHeading = 'More info',
}) => {
	const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);

	return (
		<>
			<div
				className={classNames([
					styles['label'],
					withOffset && styles['with-offset'],
					!isCapacitor && tooltip && styles['hover'],
					className,
				])}
				onClick={() => tooltip && setIsTooltipOpen(true)}
			>
				<span>{children}</span>
				{tooltip ? (
					<SvgIcon
						viewBox="0 0 16 16"
						component={questionMarkCircle}
					/>
				) : null}
			</div>

			{tooltip && isTooltipOpen ? (
				<BottomCard
					title={tooltipHeading}
					onClose={() => setIsTooltipOpen(false)}
				>
					<BottomCardForm>
						<RenderRichText
							className={styles['tooltip']}
							text={tooltip}
						/>
					</BottomCardForm>
					<BottomCardAction>
						<AsaphButton
							onClick={() => setIsTooltipOpen(false)}
							fullWidth
							label="OK, got it"
							color="blue"
						/>
					</BottomCardAction>
				</BottomCard>
			) : null}
		</>
	);
};
